import axios from 'axios';

const {
  REACT_APP_API_ROOT_URI: API_ROOT_URI,
  REACT_APP_DATABASE_USER,
  REACT_APP_DATABASE_PW,
} = process.env;

export function fetchUser({ id, signal }) {
  return axios.get(`${API_ROOT_URI}/users/${id}`, {
    signal,
    auth: {
      username: REACT_APP_DATABASE_USER,
      password: REACT_APP_DATABASE_PW,
    },
  });
}
